
<template>
    <div>
        <header-component></header-component>

        <component :is="innerWelcomeBannerComponent"></component>

        <activated-offers-component v-if="activatedOffers && activatedOffers.length > 0" :activatedOffers = "activatedOffers"></activated-offers-component>

        <!-- Featured offers slider -->
        <div>
            <search-view-component class="mb-5"></search-view-component>
            <div class="input-group mb-3">
                <input type="text" class="form-control" v-model="zip" placeholder="Enter Zip" aria-label="" aria-describedby="button-addon2">
                <button class="btn btn-outline-secondary"  @click="toggleView('list')" type="button" id="button-addon2">List</button>
                <button class="btn btn-outline-secondary"  @click="toggleView('map')" type="button" id="button-addon3">Map</button>
            </div>

            <featured-offers-slider-component v-if="showList" :featuredOffers = "featuredOffers"> </featured-offers-slider-component>

            <div v-if="showMap" style="height: 350px" class="col-md-12">
                <map-component :offerLocations = "offerLocations" :mapCenter = "mapCenter"> </map-component>
            </div>

        </div>

        <!-- Category offers -->
        <category-offers-component :matchedOffers = "category_1_offers" category="dining_and_entertainment" ></category-offers-component>
        <category-offers-component :matchedOffers = "category_2_offers" category="shopping" class="bg-grey"></category-offers-component>


        <div class="button-container no-margin">
            <a href="#" class="button rounded-0 pink midsize full-width py-5 text-center">View All Categories</a>
        </div>

        <!-- Promotional offers -->
        <promotional-offers-component></promotional-offers-component>

        <!-- Footer -->
        <footer-component>
            <template v-slot:after-links v-if="showPromotionalBanner">
                <post-login-disclosure />
            </template>
        </footer-component>
    </div>
</template>

<script>
    import InnerWelcomeBannerComponent from './banners/InnerWelcomeBannerComponent.vue';
    import InnerWelcomeBannerPromotionComponent from './banners/InnerWelcomeBannerPromotionComponent.vue';
    import ActivatedOffersComponent from './ActivatedOffersComponent.vue';
    import OffersBlockComponent from './OffersBlockComponent.vue';
    import FooterComponent from './FooterComponent.vue';
    import CategoryOffersComponent from './CategoryOffersComponent.vue';
    import HeaderComponent from './HeaderComponent.vue';
    import FeaturedOffersSliderComponent from './FeaturedOffersSliderComponent.vue';
    import PostLoginDisclosure from "./promotions/PostLoginDisclosure.vue";


    export default {
        components: {
            InnerWelcomeBannerComponent,
            InnerWelcomeBannerPromotionComponent,
            PostLoginDisclosure,
            OffersBlockComponent,
            ActivatedOffersComponent,
            FooterComponent,
            CategoryOffersComponent,
            HeaderComponent,
            FeaturedOffersSliderComponent,
        },
        data(){
            return {
                showMap: false,
                showList: true,
                zip: null,
                user: null,
                offerLocations: [],
                mapCenter: {},
                category_1_offers: [],
                category_2_offers: [],
                featuredOffers: [],
                activatedOffers: [],
                showPromotionalBanner: window.appGlobalData.showPromotionalBanner,
                innerWelcomeBannerComponent : window.appGlobalData.showPromotionalBanner?InnerWelcomeBannerPromotionComponent:InnerWelcomeBannerComponent
            }
        },
        methods : {
            getMatchedOffers(type = null, category = null) {

                let payload = {
                    PageNumber: 1,
                    ItemsPerPage: 20,
                    offset: 0,
                };



                if(type == 'featured') {
                    payload.filter = 'featured';
                }else if(type == 'activated') {
                    payload.filter = 'activated';
                }

                if(category) {
                    payload.Category = category;
                }

                axios.post(this.apiEndPoints.matchedOffers, payload).then(response => {

                    let offers = response?.data?.Response?.Items?.MatchedOffer;

                if(offers !== undefined) {

                    if(type == 'featured') {
                        this.featuredOffers = offers;
                    } else if(type == 'activated') {
                        this.activatedOffers = offers;
                    }else if(category == 'dining_and_entertainment') {
                        this.category_1_offers = offers;
                    } else if(category == 'shopping') {
                        this.category_2_offers = offers;
                    } else {
                    }
                }

                }).catch(error => {
                    // console.error(error, 'here');
                    // console.error(error.status,'here')

                    if (error.response.status == 401 || error.response.status == 419 ) {
                        this.$router.push({name : 'sign_in'});
                    }
                });

            },

            toggleView(view) {

                if(view == 'map') {
                    this.showMap = true;
                    this.showList = false;
                    this.getOffersToDisplay();
                } else {
                    this.showMap = false;
                    this.showList = true;
                    this.getMatchedOffers('featured');
                }



            },

            getOffersToDisplay() {

                let payload = {};
                payload.zip = this.zip;
                payload.PageNumber = 1;
                payload.ItemsPerPage = 20;

                if(this.showMap) {
                    payload.getOffersForMap =  1;
                }
                // e.preventDefault();
                axios.post(this.apiEndPoints.matchedOffers, payload)
                    .then(response => {

                        let matchedOffers = response?.data?.Response?.Items?.MatchedOffer;

                        if(this.showMap) {
                            if (matchedOffers !== undefined) {
                                this.offerLocations = matchedOffers.map(a => {
                                    let innerObj = a.Merchant.Addresses.Address[0];
                                    innerObj['MerchantName'] = a.Merchant.Name;
                                    return innerObj;
                                });
                            }

                            let mapCenter = response?.data?.Response?.MapCenter;

                            if (mapCenter !== undefined && mapCenter.longitude && mapCenter.latitude) {
                                this.mapCenter = mapCenter;
                            }
                        }

                        if(response.data && response.data.status) {

                            if(response.data.status == 'success') {
                                // console.log(response.data);

                                //
                                // console.log()
                            } else if(response.data.message) {
                                this.errors.push(response.data.message);
                            } else {
                                this.errors.push('An error occurred. Please try again!');
                            }
                        }
                    })
                    .catch(error => {
                        console.error(error.response);
                    });
            }
        },
        mounted() {

            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
                this.zip = this.user.postal_code;
            }

            this.getMatchedOffers(null, 'dining_and_entertainment');
            this.getMatchedOffers(null, 'shopping');
            this.getMatchedOffers('featured');
            this.getMatchedOffers('activated');

        }
    }
</script>
